export default function ActionsFooter({
  showMood = false,
  showUsage = false,
  showFeedback = false,
  onMoodClick,
  onSkinClick,
  onUsageClick,
  onFeedbackClick,
  onHelpClick,
  onChangelogClick,
}) {
  return (
    <div className="actions">
      <div className="actions__list">
        {showMood && (
          <a
            href="#!"
            onClick={(event) => {
              event.preventDefault();
              onMoodClick?.();
            }}
          >
            Mood
          </a>
        )}
        <a
          href="#!"
          onClick={(event) => {
            event.preventDefault();
            onSkinClick?.();
          }}
        >
          Skin
        </a>
        {showFeedback && (
          <a
            href="#!"
            onClick={(event) => {
              event.preventDefault();
              onFeedbackClick?.();
            }}
          >
            Feedback
          </a>
        )}
        {showUsage && (
          <a
            href="#!"
            onClick={(event) => {
              event.preventDefault();
              onUsageClick?.();
            }}
          >
            Usage
          </a>
        )}
        <a
          href="#!"
          onClick={(event) => {
            event.preventDefault();
            onHelpClick?.();
          }}
        >
          Settings
        </a>
        <a href="#!" onClick={onChangelogClick}>
          v{process.env.VERSION}
        </a>
      </div>
    </div>
  );
}
